import { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export type InputFileType = 'mosaic' | 'perimeter' | 'raw_images' | 'geotag'

export interface GetURLToUploadFileOptions {
  resumable?: boolean
  type: InputFileType
  originalFilename?: string
}

export async function getURLToUploadFile(
  treatment: Treatment,
  culture: Culture,
  demandId: string,
  { type }: GetURLToUploadFileOptions,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<{ url: string }>(
    apiRoutes.getURLToUploadFile(treatment, culture, demandId, type),
    options,
  )

  return data.url
}
